import apis from '@/services'
import { useMutation } from '@tanstack/vue-query'

export function useChatMessageMutation() {
  const { mutateAsync: sendMessageMutationAsync } = useMutation({
    mutationFn: ({ message, conversationId, context }) =>
      apis.chatbot.putMessage({ text: message, id: conversationId, context }),
  })

  return {
    sendMessageMutationAsync,
  }
}

export function useChatFeedbackMutation() {
  const { mutateAsync: sendFeedbackMutationAsync } = useMutation({
    mutationFn: ({ status, id }) => apis.chatbot.sendFeedback({ status, id }),
  })

  return {
    sendFeedbackMutationAsync,
  }
}
